import { BASE_CORE_URL, UAPI_URL_HM } from "../config";
import { HM_STATUS_API } from "../config";
import { getRequestHandler } from "../utils/utils";

//#region  to get the Health monitoring Devicestatus table data
export const getHealthMonitorData = async (
  userId,
  clientID,
  siteID,
  pageNumber,
  searchText
) => {
  let obj={
    userId,
    clientID,
    siteID,
    pageNumber,
    searchText
  }
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify(obj),
  };
    let url =
    UAPI_URL_HM  +
    "healthMonitoring/getAllDeviceStatusDetails"
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region  to get the Health Monitoring Dashboard Widget Data
export const AllWidgetData = async (userUniqueID, clientIds, siteIds) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url =
    BASE_CORE_URL +
    "HealthMonitoringDashboard/AllWidgetData?userUniqueId=" +
    userUniqueID +
    "&clientIds=" +
    clientIds +
    "&siteIds=" +
    siteIds;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("AllWidgetData () Exception", error);
    });
};
//#endregion

//#region  to get the Health Monitoring table single device data
export const getSelectedDeviceHealthData = async (
  uniqueId,
  deviceId,
  deviceStatusType,
  fromDateTime,
  toDateTime,
  pageNumber,
  searchText,
  diskNumber
) => {
  let fromDateTimeTemp = fromDateTime.replaceAll(":", "%3A");
  fromDateTimeTemp = fromDateTimeTemp.replace(" ", "%20");
  let toDateTimeTemp = toDateTime.replace(" ", "%20");
  toDateTimeTemp = toDateTimeTemp.replaceAll(":", "%3A");

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url =
  UAPI_URL_HM +
    "healthMonitoring/getUpdownTimeChartDetail?userId=" +
    uniqueId +
    "&deviceid=" +
    deviceId +
    "&deviceStatusType=" +
    deviceStatusType +
    "&fromdatetime=" +
    fromDateTime +
    "&todatetime=" +
    toDateTime +
    "&pageNumber=" +
    pageNumber +
    "&searchText=" +
    searchText +
    "&Disknumber=" +
    diskNumber
    ;
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region  to get the Health Monitoring table single device data export (downaload)
export const getSingleDeviceStatusDetails = async (
  uniqueId,
  deviceId,
  deviceType,
  fromDateTime,
  toDateTime,
  pageNumber,
  searchText,
  diskNumber
) => {
  let fromDateTimeTemp = fromDateTime.replaceAll(":", "%3A");
  fromDateTimeTemp = fromDateTimeTemp.replace(" ", "%20");
  let toDateTimeTemp = toDateTime.replace(" ", "%20");
  toDateTimeTemp = toDateTimeTemp.replaceAll(":", "%3A");

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url =
  UAPI_URL_HM +
    "healthMonitoring/getUpdownTimeChartDetail?userId=" +
    uniqueId +
    "&deviceid=" +
    deviceId +
    "&deviceStatusType=" +
    deviceType +
    "&fromdatetime=" +
    fromDateTime +
    "&todatetime=" +
    toDateTime +
    "&pageNumber=" +
    pageNumber +
    "&searchText=" +
    searchText +
    "&Disknumber=" +
    diskNumber +
    "&isExport=true";
  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
    });
};
//#endregion

//#region  to get the Health monitoring dashboard widget Camera Tampering For Today (to view details)
export const getCameraTampAlerts = async (
  userId,
  clientID,
  siteID,
  pageNumber,
  searchText
) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

    let url =
    UAPI_URL_HM +
    "healthMonitoring/getCameraBlockAlertsDetails?userId=" +
    userId +
    "&clientID=" +
    clientID +
    "&siteID=" +
    siteID +
    "&pageNumber=" +
    pageNumber +
    "&searchText=" +
    searchText;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};
//#endregion

//#region to get the Health Monitoring single device  Barchart Data
export const getBarChartDataFromAPI = async (
  uniqueId,
  deviceId,
  deviceType,
  fromDateTime,
  toDateTime,
  deviceStatusType,
  diskNumber
) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };

  let url =
  UAPI_URL_HM +
    "healthMonitoring/getUpdownTimeChart?userId=" +
    uniqueId +
    "&deviceid=" +
    deviceId +
    "&deviceType=" +
    deviceType +
    "&fromdatetime=" +
    fromDateTime +
    "&todatetime=" +
    toDateTime +
    "&deviceStatusType=" +
    deviceStatusType +
    "&Disknumber=" +
    diskNumber;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => console.log(err));
};

//#region to get the Health Monitoring based on SiteId
export const getHealthMonitoringSiteID = async (siteId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = HM_STATUS_API + "GetStatusDevice?siteId=" + siteId;

  return await fetch(url, requestOptions)
    .then((res) => res.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
};

//#endregion

//#region get Health Monitoring DashBoard System Health Count 
export const getHMSystemHealthData = async (userId, clientID,siteID) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = 
  UAPI_URL_HM + 
  "healthMonitoring/getStatusPercent?userId=" + 
  userId +
  "&clientID=" +
  clientID +
  "&siteID=" +
  siteID;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getHMSystemHealthData () Exception", error);
    });
};
//#endregion

//#region get Health Monitoring CameraBlock Alerts Count  
export const getHMCameraBlockAlerts = async (userId, clientID,siteID) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = 
  UAPI_URL_HM + 
  "healthMonitoring/getCameraBlockAlerts?userId=" + 
  userId +
  "&clientID=" +
  clientID +
  "&siteID=" +
  siteID;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getHMCameraBlockAlerts() Exception", error);
    });
};
//#endregion

//#region get Health Monitoring IDS Sensor State Count  
export const getSensorState = async (userId, clientID,siteID) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = 
  UAPI_URL_HM + 
  "healthMonitoring/getIDSSensorState?userId=" + 
  userId +
  "&clientID=" +
  clientID +
  "&siteID=" +
  siteID;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getSensorState() Exception", error);
    });
};
//#endregion

//#region get Health Monitoring Top 3 Offline Devices todays Count
export const getTopThreeOfflineWidgetCount = async (userId,clientID,siteID,fromdatetime = "",todatetime = "") => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = 
  UAPI_URL_HM + 
  "healthMonitoring/getOfflineCameraWidget?userId=" + 
  userId +
  "&fromdatetime=" +
  fromdatetime +
  "&todatetime=" +
  todatetime +
  "&clientID=" +
  clientID +
  "&siteID=" +
  siteID;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getTopThreeOfflineWidgetCount() Exception", error);
    });
};
//#endregion

//#region get Health Monitoring NVR/DVR/HDD/Cameras Count 
export const getNvrDvrHddCamerasCount = async (userId, clientID,siteID) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = 
  UAPI_URL_HM + 
  "healthMonitoring/getAllDeviceStatusCount?userId=" + 
  userId +
  "&clientID=" +
  clientID +
  "&siteID=" +
  siteID;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getNvrDvrHddCamerasCount() Exception", error);
    });
};
//#endregion

//#region get Health Monitoring Panel Count 
export const getPanelCount = async (userId, clientID,siteID) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = 
  UAPI_URL_HM + 
  "healthMonitoring/getAllIDSDeviceStatusCount?userId=" + 
  userId +
  "&clientID=" +
  clientID +
  "&siteID=" +
  siteID;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getPanelCount() Exception", error);
    });
};
//#endregion

//#region get Health Monitoring ACS Count 
export const getACSCount = async (userId, clientID,siteID) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
  };
  let url = 
  UAPI_URL_HM + 
  "healthMonitoring/getAllACSDeviceStatusCount?userId=" + 
  userId +
  "&clientID=" +
  clientID +
  "&siteID=" +
  siteID;
  return await fetch(url, requestOptions)
    .then((resp) => {
      return resp.json();
    })
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getACSCount() Exception", error);
    });
};

export const getLatestCameraStatus = async (deviceId,currentStatus) => {
  let url = UAPI_URL_HM + "healthMonitoring/getCameraStreamStatus?deviceId=" + deviceId + "&currentStatus=" + currentStatus;
  return getRequestHandler(url);
}
//#endregion